export const gamesIndex: any = {
    1: "kite",
    2: "box",
    3: "fish",
    4: "pinguin",
    quiz: "test",
    test: "test",
};
